import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-shell-v1',
  templateUrl: './app-shell-v1.component.html',
  styleUrls: ['./app-shell-v1.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppShellV1Component {
  @Input() loginURL: string | null = null;
}
